import { combineReducers } from 'redux';

import { OrderState } from './types';
import travellersReducer from './travellers/reducers';

const rootReducer = combineReducers<OrderState>({
	travellers: travellersReducer
});

export default rootReducer;
